
function updateCartTerms(checked) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: "attributes[Terms]=" + (checked ? "Yes" : "no")
    });
}
if(document.getElementById("CartTerms")){
	document.getElementById("CartTerms").addEventListener("change", function() {
		updateCartTerms(this.checked);
	});
}
if(document.getElementById("CartTermsDrawer")){
	document.getElementById("CartTermsDrawer").addEventListener("change", function() {
		updateCartTerms(this.checked);
	});
}

function addCheckoutEvent() {
    document.querySelectorAll("[name='checkout']").forEach(function(checkoutButton) {
        checkoutButton.addEventListener("click", function(e) {
            var error = false;
            document.querySelectorAll(".form-field--checkbox").forEach(function(field) {
                var checkbox = field.querySelector('input[type=checkbox]');
                if (checkbox && checkbox.classList.contains("required") && !checkbox.checked) {
                    field.classList.add("error");
                   error = true;
                } else {
                    field.classList.remove("error");
                }
            });
            if (error) {
                e.preventDefault();
            }
        });
    });
}
document.addEventListener("DOMContentLoaded", function() {
    addCheckoutEvent();
	// setTimeout(function(){
	// 	addCheckoutEvent();
	// }, 1000);
});
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    });
});
var afdelingSelect = document.getElementById("RegisterFormAfdeling");
if(afdelingSelect){
    afdelingSelect.required = true;
}

document.addEventListener("DOMContentLoaded", function() {
    afdelingSelect = document.getElementById("RegisterFormAfdeling");
    if (!afdelingSelect) return;
    afdelingSelect.required = true;

    var tagsInput = document.querySelector("input[name='customer[tags]'][data-handle]");
    var noteInput = document.querySelector("input[name='customer[note]'][data-handle]");
    if (!tagsInput || !noteInput) return;

    var baseTags = tagsInput.getAttribute("data-handle") || tagsInput.value || "";
    var baseNote = noteInput.getAttribute("data-handle") || noteInput.value || "";

    function updateHiddenFields() {
        var selected = (afdelingSelect.value || "").trim();
        var selectedLower = selected.toLowerCase();
        tagsInput.value = selectedLower ? (baseTags ? baseTags + "-" + selectedLower : selectedLower) : baseTags;
        noteInput.value = selectedLower ? (baseNote ? "B2B-" + baseNote + "-" + selectedLower : "B2B-" + selectedLower) : baseNote;
    }
    afdelingSelect.addEventListener("change", updateHiddenFields);

    // Enforce selection before submit and show inline error state
    var registerForm = afdelingSelect.form;
    if (registerForm) {
        registerForm.addEventListener("submit", function(e) {
            if (!afdelingSelect.value) {
                afdelingSelect.setCustomValidity("Vælg afdeling");
                if (typeof afdelingSelect.reportValidity === "function") {
                    afdelingSelect.reportValidity();
                }
                var field = typeof afdelingSelect.closest === "function" ? afdelingSelect.closest(".field") : null;
                if (field) { field.classList.add("error"); }
                e.preventDefault();
                afdelingSelect.focus();
                return false;
            } else {
                afdelingSelect.setCustomValidity("");
                var fieldClear = typeof afdelingSelect.closest === "function" ? afdelingSelect.closest(".field") : null;
                if (fieldClear) { fieldClear.classList.remove("error"); }
            }
        });
    }

    afdelingSelect.addEventListener("change", function() {
        afdelingSelect.setCustomValidity("");
        var field = typeof afdelingSelect.closest === "function" ? afdelingSelect.closest(".field") : null;
        if (field) { field.classList.remove("error"); }
        updateHiddenFields();
    });
    updateHiddenFields();
});

document.addEventListener("DOMContentLoaded", function() {
	var reloading = false;
	var selector = '[data-testid="banner-success"]';
	var pollCount = 0;
	var debugShadowHosts = 0;

	function scheduleReload() {
		if (reloading) return;
		reloading = true;
		console.log('[banner-success] Found. Reloading in ~10s…');
		setTimeout(function() {
			window.location.reload();
		}, 10000);
	}

	function existsInShadow(selector, root) {
		try {
			// Direct lookup in this root
			if (root.querySelector && root.querySelector(selector)) return true;
			// Traverse elements and any open shadow roots
			var all = root.querySelectorAll ? root.querySelectorAll('*') : [];
			for (var i = 0; i < all.length; i++) {
				var el = all[i];
				if (el.shadowRoot) {
					debugShadowHosts++;
					// Check inside this shadow root
					if (el.shadowRoot.querySelector && el.shadowRoot.querySelector(selector)) return true;
					// Recurse into nested shadow roots
					if (existsInShadow(selector, el.shadowRoot)) return true;
				}
			}
		} catch (e) {}
		return false;
	}

	var poll = setInterval(function() {
		pollCount++;
		debugShadowHosts = 0;
		if (reloading) {
			clearInterval(poll);
			return;
		}
		try {
			if (document.querySelector(selector) || existsInShadow(selector, document)) {
				clearInterval(poll);
				scheduleReload();
			} else if (pollCount % 5 === 0) {
				// console.log('[banner-success] Not found yet. Shadow hosts scanned:', debugShadowHosts, 'Polls:', pollCount);
			}
		} catch (e) {}
	}, 2500);
});
